import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { GetDashboardCasesQuery } from './get-dashboard-cases.query';
import { GetDashboardCasesResult } from './get-dashboard-cases.result';

@Injectable({ providedIn: 'root' })
export class GetDashboardCasesUseCase {
  private readonly _repository = inject(CasesRepository);

  public execute(query: GetDashboardCasesQuery): Observable<GetDashboardCasesResult> {
    let params = new HttpParams()
      .set('Skip', query.skip.toString())
      .set('Take', query.take.toString());

    if (query.sort) {
      params = params.set('Sort', query.sort);
    }
    if (query.filter) {
      params = params.set('Filter', query.filter);
    }
    if (query.search && query.search.trim()) {
      params = params.set('search', query.search.trim());
    }
    if (query.scopeTimeframe) {
      params = params.set('scopeTimeframe', 'true');
    }

    return this._repository.getDashboardCases(params);
  }
}
